import PropTypes from 'prop-types';
import ArticleContents from 'components/articles/articleContents';
import ArticleFav from 'components/articles/articleFav';
import EmailModal from 'components/layout/emailModal';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import PageFooter from 'components/layout/pageFooter';
import React from 'react';
import session from 'services/sessionService';
import {emailSendingTypes, countries} from 'helpers/constants';
import {intlShape, injectIntl} from 'react-intl';
import encyclopediaApi from 'api/encyclopedia';
import Loader from 'components/loader';
import dealerApi from 'api/dealer';
import Dealer from 'models/dealer';

// Page object
class EncyclopediaArticlePage extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    slug: PropTypes.string,
  };

  state = {
    topic: '',
    query: '',
    article: undefined,
    topics: [],
    dealer: new Dealer({}),
  };

  componentWillMount() {
    dealerApi.getDealer(session.getUser().dealerId).then(dealer => this.setState({dealer}));
  }

  componentDidMount() {
    this.fetchCurrentArticle(this.props.slug);
  }

  componentWillReceiveProps(newProps) {
    this.fetchCurrentArticle(newProps.slug);
  }

  changeHandler = (property, after = null, valueProperty = 'value') => {
    return event => {
      this.setState({
        [property]: event.target[valueProperty],
      });
      if (after) {
        after();
      }
    };
  };

  fetchCurrentArticle = slug => {
    let {formatMessage} = this.props.intl;

    encyclopediaApi
        .getArticleFromEncyclopedia(slug)
        .then(article => {
          const {
            title,
            detailedSection: body,
            id,
            fav,
            url,
            enablePDFPreview,
            enableContentDownload,
            type,
            description,
          } = article;

          this.setState({article: {title, body, id, url, fav, enablePDFPreview, enableContentDownload, type, description}});
        })
        .catch(error => {
          if (error.code === 404) {
            let article = {
              title: formatMessage({id: 'general.article.not.found'}),
              body: formatMessage({id: 'general.not.article.requested'}),
            };

            this.setState({article});
          } else {
            throw error;
          }
        });
  };

  filterChange = (text, submitted) => {
    this.setState({query: text});

    if (submitted) {
      session.setSearch(text, this.state.topic);
      window.location.hash = 'encyclopedia';
    }
  };

  render() {
    let {formatMessage} = this.props.intl;
    const externalLink = this.state.article && this.state.article.url;
    const embeddPDF =  externalLink && !this.state.article.enablePDFPreview;
    const downloadableFile = externalLink && this.state.article.enableContentDownload && this.state.article.enablePDFPreview;
    const shelfArticleFormatted = {...this.state.article, detailedSection: this.state.article ? this.state.article.body : null};

    return (
      <div className="page-encyclopedia-article container">
        <Loader loaded={!!this.state.article}>
          <ArticleFav article={this.state.article} />
          <ArticleContents article={this.state.article} formatMessage={formatMessage} />
        </Loader>
        <PageFooter>
          {!embeddPDF && !downloadableFile ?
            <FooterButton
              label={formatMessage({id: 'general.print'})}
              icon="bl bl-print fa-2x"
              onClick={() =>
                events.publish('print', <ArticleContents article={this.state.article} formatMessage={formatMessage} />)
              }
            /> : null
          }
          {this.state.dealer.country !== countries.CA ?  //CA is CASL restrcted
            <EmailModal
              title="Article"
              shelfArticle={shelfArticleFormatted}
              type={emailSendingTypes.encyclopedia}
            /> :
           null}
        </PageFooter>
      </div>
    );
  }
}

const WrappedEncyclopediaArticlePage = injectIntl(EncyclopediaArticlePage);

export default WrappedEncyclopediaArticlePage;
